import { jsx as _jsx } from "react/jsx-runtime";
import { Typography, getTestId } from '@airtel/air-design-system';
import { View } from 'react-native';
import { TEXT_TYPE } from '../../TaskCardWidgetConstants';
import { getHeadingTaskCardStyles } from './HeadingTaskCardStyles';
export var HeadingTaskCardTab = props => {
  var singleTaskCardDetails = props.singleTaskCardDetails,
    isMobileScreen = props.isMobileScreen,
    onUserAction = props.onUserAction;
  var headingTabStyles = getHeadingTaskCardStyles();
  return _jsx(View, Object.assign({
    style: [headingTabStyles === null || headingTabStyles === void 0 ? void 0 : headingTabStyles.headerWrapper, !(singleTaskCardDetails === null || singleTaskCardDetails === void 0 ? void 0 : singleTaskCardDetails.subtitleText) && headingTabStyles.headerWrapperNullStartElement]
  }, {
    children: !!(singleTaskCardDetails === null || singleTaskCardDetails === void 0 ? void 0 : singleTaskCardDetails.subtitleText) && _jsx(View, Object.assign({
      style: headingTabStyles.headerTextWrapper
    }, {
      children: _jsx(Typography, Object.assign({
        type: isMobileScreen ? TEXT_TYPE.BODY_PARA_LG_BOLD : TEXT_TYPE.BODY_PARA_XL_BOLD,
        isHyperLink: singleTaskCardDetails === null || singleTaskCardDetails === void 0 ? void 0 : singleTaskCardDetails.isSubtitleTextClickable,
        onPress: event => {
          (singleTaskCardDetails === null || singleTaskCardDetails === void 0 ? void 0 : singleTaskCardDetails.subtitleTextOnPressMetaData) && (onUserAction === null || onUserAction === void 0 ? void 0 : onUserAction(Object.assign(Object.assign({}, singleTaskCardDetails === null || singleTaskCardDetails === void 0 ? void 0 : singleTaskCardDetails.subtitleTextOnPressMetaData), {
            event
          }), props));
        },
        text: singleTaskCardDetails === null || singleTaskCardDetails === void 0 ? void 0 : singleTaskCardDetails.subtitleText
      }, getTestId(props === null || props === void 0 ? void 0 : props.testID, 'subtitleText')))
    }))
  }));
};
export default HeadingTaskCardTab;